const INTERNAL_URL_ORIGIN = "https://vaultgrid.net";

const parseInternalPath = (rawPath) => {
  try {
    return new URL(String(rawPath || ""), INTERNAL_URL_ORIGIN);
  } catch {
    return null;
  }
};

export function normalizeAttendanceClaimPath(rawPath) {
  const parsed = parseInternalPath(rawPath);
  const token = parsed?.searchParams.get("host_claim");
  if (!token) return rawPath;

  const params = new URLSearchParams({ host_claim: token });
  return `/events/search?${params.toString()}`;
}

export function removeAttendanceClaimFromLocation(location) {
  const pathname = String(location?.pathname || "/") || "/";
  const params = new URLSearchParams(String(location?.search || ""));
  params.delete("host_claim");

  const search = params.toString();
  const hash = String(location?.hash || "");
  return `${pathname}${search ? `?${search}` : ""}${hash}`;
}
